import React, { useEffect } from "react";
import styles from "./Legal.module.css";

export default function Impressum() {
  useEffect(() => {
    document.title = "Impressum – Dr. Fernando International GmbH";
  }, []);

  return (
    <main className={styles.page}>
      <header className={styles.hero}>
        <div className={styles.heroOverline}>Rechtliches</div>
        <h1 className={styles.heroTitle}>Impressum</h1>
        <p className={styles.heroDesc}>
          Angaben gemäß § 5 DDG
        </p>
      </header>

      <nav className={styles.toc} aria-label="Inhaltsverzeichnis">
        <h3>Inhalt</h3>
        <ul>
          <li>
            <a href="#anbieter">Angaben gemäß § 5 DDG</a>
          </li>
          <li>
            <a href="#kontakt">Kontakt</a>
          </li>
          <li>
            <a href="#vertretung">Vertreten durch</a>
          </li>
          <li>
            <a href="#register">Registereintrag</a>
          </li>
          <li>
            <a href="#ust">Umsatzsteuer-ID</a>
          </li>
          <li>
            <a href="#gewerbe">Gewerbeerlaubnis</a>
          </li>
          <li>
            <a href="#verantwortlich">Inhaltlich verantwortlich</a>
          </li>
          <li>
            <a href="#haftung">Haftungsausschluss</a>
          </li>
          <li>
            <a href="#links">Links zu externen Websites</a>
          </li>
          <li>
            <a href="#urheber">Urheberrecht</a>
          </li>
          <li>
            <a href="#vssb">Verbraucherstreitbeilegung</a>
          </li>
          <li>
            <a href="#oss">Verwendete Open-Source-Komponenten</a>
          </li>
        </ul>
      </nav>

      <div className={styles.content}>
        <section id="anbieter" className={styles.section}>
          <h2>Angaben gemäß § 5 DDG</h2>
          <dl className={styles.dl}>
            <dt>Unternehmen</dt>
            <dd>Dr. Fernando International GmbH</dd>

            <dt>Adresse</dt>
            <dd>
              Grunewaldstraße 24
              <br />
              12165 Berlin
              <br />
              Deutschland
            </dd>
          </dl>
        </section>

        <section id="kontakt" className={styles.section}>
          <h2>Kontakt</h2>
          <p>
            Telefon: <a href="tel:+493037436370">+49 30 37 43 63 70</a>
            <br />
            Fax: +49 30 80 58 19 28
            <br />
            E-Mail:{" "}
            <a href="mailto:info@fernando-international.com">
              info@fernando-international.com
            </a>
          </p>
        </section>

        <section id="vertretung" className={styles.section}>
          <h2>Vertreten durch</h2>
          <p>Geschäftsführer: Dr. Douglas Fernando</p>
        </section>

        <section id="register" className={styles.section}>
          <h2>Registereintrag</h2>
          <dl className={styles.dl}>
            <dt>Handelsregister</dt>
            <dd>Amtsgericht Charlottenburg (Berlin)</dd>

            <dt>Registernummer</dt>
            <dd>HRB 95019 B</dd>
          </dl>
        </section>

        <section id="ust" className={styles.section}>
          <h2>Umsatzsteuer-ID</h2>
          <p>
            Umsatzsteuer-Identifikationsnummer gemäß § 27 a UStG
            <br />
            <strong>DE 241 829 322</strong>
            <br />
          </p>
        </section>

        <section id="gewerbe" className={styles.section}>
          <h2>Gewerbeerlaubnis</h2>
          <p>
          Die Dr. Fernando International GmbH besitzt die Erlaubnis nach § 34c GewO. Zuständige Aufsichtsbehörde gemäß § 34c GewO: Bezirksamt Steglitz-Zehlendorf von Berlin, Unter den Eichen 1, 12203 Berlin.
          </p>
        </section>

        <section id="verantwortlich" className={styles.section}>
          <h2>Inhaltlich verantwortlich für den Inhalt nach § 18 Abs. 2 Medienstaatsvertrag (MStV) </h2>
          <p>
          
            <br />
            Dr. Douglas Fernando.
          </p>
        </section>

        <section id="haftung" className={styles.section}>
          <h2>Haftungsausschluss</h2>
          <p>
            Diese Website stellt den aktuellen Stand eines kontinuierlichen
            Arbeitsprozesses dar. Trotz sorgfältiger Prüfung können wir keine
            Gewähr für die Vollständigkeit, Richtigkeit und Aktualität der
            Inhalte übernehmen.
          </p>
          <p>
            Haftungsansprüche gegen die Dr. Fernando International GmbH, die
            sich auf Schäden materieller oder ideeller Art beziehen, die durch
            die Nutzung oder Nichtnutzung der angebotenen Informationen bzw.
            durch fehlerhafte oder unvollständige Informationen verursacht
            wurden, sind ausgeschlossen, sofern kein nachweislich vorsätzliches
            oder grob fahrlässiges Verschulden vorliegt. Änderungen oder
            Ergänzungen der Inhalte behalten wir uns jederzeit ohne vorherige
            Ankündigung vor.
          </p>
        </section>

        <section id="links" className={styles.section}>
          <h2>Links zu externen Websites</h2>
          <p>
            Unsere Website enthält Links zu externen Webseiten Dritter, auf
            deren Inhalte wir keinen Einfluss haben. Für die Inhalte der
            verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber
            verantwortlich.
          </p>
          <p>
            Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links
            umgehend entfernen.
          </p>
        </section>

        <section id="urheber" className={styles.section}>
          <h2>Urheberrecht</h2>
          <p>
            Die durch die Dr. Fernando International GmbH erstellten Inhalte und
            Werke auf dieser Website unterliegen dem deutschen Urheberrecht. Die
            Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
            Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
            schriftlichen Zustimmung der Dr. Fernando International GmbH.
          </p>
        </section>

        <section id="vssb" className={styles.section}>
          <h2>Verbraucherstreitbeilegung</h2>
          <p>
           Wir nehmen an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle nicht teil und sind dazu auch nicht verpflichtet.
          </p>
        </section>

        <section id="oss" className={styles.section}>
          <h2>Verwendete Open-Source-Komponenten</h2>
      <p>
        Diese Website verwendet Symbole von{" "}
        <a href="https://lucide.dev/" target="_blank" rel="noopener noreferrer">
          Lucide Icons
        </a>{" "}
        unter der{" "}
        <a
          href="https://github.com/lucide-icons/lucide/blob/main/LICENSE"
          target="_blank"
          rel="noopener noreferrer"
        >
          ISC-Lizenz
        </a>
        .<br />
        Copyright © 2013–2023 Cole Bemis (Feather Icons) und © 2025 Lucide Contributors.
      </p>
      <p>
        Die Verwendung erfolgt gemäß den Bedingungen der ISC-Lizenz. Eine kommerzielle Nutzung ist
        erlaubt, sofern der obige Urheberrechtshinweis und die Lizenzbedingungen in allen Kopien
        enthalten sind.
      </p>
        </section>
      </div>
    </main>
  );
}
